import React from 'react'
import { string, object } from 'prop-types'
import { EventSponsorHero } from '@/component/Primitive/Events'

const EventSponsorHeroWidget = (props) => {
  const { images, sponsor, backgroundVideoYoutubeId, title, subtitle } = props

  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]

  const backgroundImage = getImage('desktop_background', '72x17', 1440)?.url

  return (
    <EventSponsorHero
      sponsor={sponsor}
      backgroundImage={backgroundImage}
      backgroundVideoYoutubeId={backgroundVideoYoutubeId}
      title={title}
      subtitle={subtitle}
    />
  )
}

EventSponsorHeroWidget.propTypes = {
  title: string,
  subtitle: string,
  images: object,
  backgroundVideoYoutubeId: string,
  sponsor: object
}

export default EventSponsorHeroWidget
